<template>
    <div id="app">
        <router-view v-if="RESOURCE_LOAD_COMPLETE"></router-view>
        <alert @API="alertAPI = $event" :message="alertOPT.message" :type="alertOPT.type" :closeModal="alertOPT.action"></alert>
    </div>
</template>
<script>
import loki_db_loader from '../mixins/loki_db_loader';
import AppOnlineLoaderMixin from './AppOnlineLoaderMixin';
import AppOfflineLoaderMixin from './AppOfflineLoaderMixin';
import { eventBus } from "../eventbus.js";
import Alert from "./dynamic/modalWrapper/Alert.vue"
import utils from '../../utils/utilities.js'

var loading_screen = pleaseWait({
    logo: "/../static/img/activepostsalelogo.svg",
    backgroundColor: '#3c8dbc',
    loadingHtml: '<p class="loading-message"></p><div class="sk-cube-grid"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div><div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>'
});

export default {
    name: 'App',
	components: {Alert},						 
    mixins: [loki_db_loader, AppOnlineLoaderMixin, AppOfflineLoaderMixin],
    mounted:function(){
        this.loading_screen = loading_screen;
        
        var offline = false;
        if(front_end_configs && front_end_configs.default_preferences && front_end_configs.default_preferences.useOffline == true){
            offline = true;
        }
        if(offline){
            this.offlineLoadStart()
        } else {
            this.onlineLoadStart()
        }  
    },
    data() {
        return {
            section: 'Head',
            RESOURCE_LOAD_COMPLETE: false,
			alertAPI: null,
            alertOPT: { type: "", message: "", action: function(){this.logout()}},

            registry_record: null,
            registryStillToBeLoaded : false
        }
    },
    methods: {
        logout() {
            this.$root.logout();
        },
        setLoadingMessage(message) {
            let element = document.querySelector('.pg-loading-html .loading-message');
            if (element && message) {
                if(element.innerHTML.includes(message)){
                    element.innerHTML = element.innerHTML.replace(message, message+this.$Jed.firstUpperTranslate('done', null))
                }else{
                    element.innerHTML+='<br>'+message
                }
            }
        }
    }
}
</script>
<style>
    /* i.disable {
        opacity: 0.6;
    } */
	.sweet-modal .sweet-box-actions .sweet-action-close:hover{
        background: none !important;
        color: black !important;
    }								
    
    @-webkit-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-moz-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-ms-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-moz-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-o-keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes uil-rolling-anim {
        0% {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        50% {
            -ms-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -webkit-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        100% {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .uil-rolling-css {
        width: 200px;
        height: 200px;
    }

    .uil-rolling-css > div {
        width: 200px;
        height: 200px;
        position: relative;
        -ms-animation: uil-rolling-anim 1s linear infinite;
        -moz-animation: uil-rolling-anim 1s linear infinite;
        -webkit-animation: uil-rolling-anim 1s linear infinite;
        -o-animation: uil-rolling-anim 1s linear infinite;
        animation: uil-rolling-anim 1s linear infinite;
    }

    .uil-rolling-css > div div {
        position: absolute;
        width: 200px;
        height: 100px;
        border-radius: 1000px 1000px 0 0;
        border-color: rgb(66, 165, 245);
        border-style: solid;
        border-width: 40px;
        border-bottom-width: 0;
    }

    .uil-rolling-css > div div:nth-of-type(2) {
        -ms-transform: translate(0, 50px) rotate(54deg) translate(0, -50px);
        -moz-transform: translate(0, 50px) rotate(54deg) translate(0, -50px);
        -webkit-transform: translate(0, 50px) rotate(54deg) translate(0, -50px);
        -o-transform: translate(0, 50px) rotate(54deg) translate(0, -50px);
        transform: translate(0, 50px) rotate(54deg) translate(0, -50px);
    }

    @keyframes custom_spinner {
    to {transform: rotate(360deg);}
    }
    
    .custom_spinner {
        position: relative;
        display: inline-block;
        width: 25px;
    }

    .custom_spinner:before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 15px;
    height: 15px;
    margin-top: -12px;
    margin-left: -8px;
    border-radius: 50%;
    border-top: 2px solid rgb(93, 197, 150);
    border-right: 2px solid transparent;
    animation: custom_spinner .7s linear infinite;
    }

    html, body, div#app, div#app > .wrapper {
        height: 100%;
    }

    body {
        overflow: hidden;
    }

    .checkbox-component > input + label > .input-box{
    border-color: rgb(150, 150, 150) !important;
    background: rgb(102, 102, 102) !important;
    }
    .checkbox-component > input + label > .input-box > .input-box-tick > path {
    stroke: #fff !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>



// WEBPACK FOOTER //
// src/components/App.vue?1bad2011